<!--
  @component
  Generates an SVG area shape using the `area` function from [d3-shape](https://github.com/d3/d3-shape).
 -->
<script>
	import { tweened } from "svelte/motion";
	import { getContext } from "svelte";
	import { cubicOut } from "svelte/easing";
	import { line, curveMonotoneX } from "d3-shape";

	const { data, xGet, yGet } = getContext("LayerCake");

	/** @type {String} [stroke='#ab00d6'] - The shape's fill color. This is technically optional because it comes with a default value but you'll likely want to replace it with your own color. */
	export let stroke = "#ab00d6";

	export let strokeWidth = 2;

	$: coordinates = $data.map((d) => [$xGet(d), $yGet(d)]);
	const tCoordinates = tweened(coordinates, { delay: 100, duration: 300, easing: cubicOut });
	$: tCoordinates.set(coordinates);

	// $: path =
	// 	"M" +
	// 	$tCoordinates
	// 		.map(([x, y]) => {
	// 			return x + "," + y;
	// 		})
	// 		.join("L");

	const lineGenerator = line()
		.x(([x]) => x)
		.y(([, y]) => y)
		.curve(curveMonotoneX);

	$: path = lineGenerator($tCoordinates);
</script>

<path class="path-line" d={path} {stroke} stroke-width={strokeWidth} />

<style>
	.path-line {
		fill: none;
		stroke-linejoin: round;
		stroke-linecap: round;
		stroke-width: 2;
	}
</style>
